import React from 'react';

function Home_Specialized() {
  return (
    <div className="max-w-screen-xl	mx-auto text-center">
      <main className="mt-10">
        <p className="font-bold text-sm py-6">I SPECIALIZED IN</p>
        <div className="container mx-auto flex flex-wrap flex-col items-end justify-between md:flex-row md:items-center md:justify-center sm:items-center sm:justify-center py-10 px-0">
          <div className="lg:w-2/12 md:w-4/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-10">
              <img src={require('../../common/images/home/user_experience.svg')} alt="User Experience Art"/>
            </div>
            <p className="mt-10 text-xs">User Experience</p>
          </div>
          <div className="lg:w-2/12 md:w-4/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-10">
              <img src={require('../../common/images/home/interactive_design.svg')} alt="Interactive Design Art"/>
            </div>
            <p className="mt-10 text-xs">Interactive Design</p>
          </div>
          <div className="lg:w-2/12 md:w-4/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-10">
              <img src={require('../../common/images/home/web_design.svg')} alt="Web Design Art"/>
            </div>
            <p className="mt-10 text-xs">Web Design</p>
          </div>
          <div className="lg:w-2/12 md:w-4/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-10">
              <img src={require('../../common/images/home/mobile_design.svg')} alt="Mobile Design Art"/>
            </div>
            <p className="mt-10 text-xs">Mobile Design</p>
          </div>
          <div className="lg:w-2/12 md:w-4/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-10">
              <img src={require('../../common/images/home/branding.svg')} alt="Branding Art"/>
            </div>
            <p className="mt-10 text-xs">Branding</p>
          </div>
          <div className="lg:w-2/12 md:w-4/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-10">
              <img src={require('../../common/images/home/project_management.svg')} alt="Project Management Art"/>
            </div>
            <p className="mt-10 text-xs">Project Management</p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Home_Specialized;
